<template>
    <!-- 弹窗遮罩 -->
    <div class="lite_popup lite_input" v-show="show">
        <!-- 弹窗 -->
        <div class="lite_popup_box">
            <!-- 标题栏 -->
            <div class="lite_popup_title">
                <!-- 标题 -->
                <span>{{ data.title }}</span>
                <!-- 关闭图标 -->
                <div class="icon white-close dialog-close" @click="show = false"></div>
            </div>
            <!-- 内容 -->
            <div class="lite_popup_content">
                <el-input ref="input" @keyup.esc.native="show = false" @keyup.enter.native="ok" v-model="data.value" :placeholder="data.placeholder || $t('language.cloudExploer.inputPlaceholder')" :maxlength="maxlength"></el-input>
            </div>
            <div class="lite_popup_footer">
                <!-- 按钮 -->
                <button @click="ok">
                    <i v-if="loading" class="el-icon-loading" style="color:#fff;"></i>
                    <span>{{$t('language.common.ok')}}</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { Message } from "element-ui";

export default {
    props: {
        maxlength: { type: Number, default: 255 },
        autoClose: { type: Boolean, default: true },
        data: {
            title: { type: String, default: 'Title' },
            value: { type: String, default: '' },
            placeholder: { type: String, default: 'Input Content' },
        }
    },
    data() {
        return {
            show: false,
            loading: false,
        };
    },
    watch: {
        show(val) {
            if (val) {
                this.$nextTick(() => {
                    this.$refs.input.select();
                    this.$refs.input.focus();
                });
            }
        }
    },
    methods: {
        ok() {
            if (!this.data.value) {
                Message.warning(this.$t('language.cloudExploer.pleaseInputContent'));
            } else if (/[\\\/:*?"<>|]/.test(this.data.value)) {
                Message.warning(this.$t('language.cloudExploer.notContainSpecialChar'));
            } else {
                if (this.autoClose) {
                    this.show = false
                }
                this.$emit('ok');
            }
        },
    }
};
</script>

<style>
/* 弹窗宽度 */
.lite_input .lite_popup_box {
    width: 400px;
}

/* 输入框样式 */
.el-input__inner:focus {
  border-color: #5166BD;
}
</style>


// WEBPACK FOOTER //
// src/components/workspace/lite_input.vue